/* Pure cart contract. No I/O and no fixture or guessed plan identifiers. */
(() => {
  'use strict';
  const PRODUCT_ID = '8268127502436';
  const VARIANTS = {
    '12': {id: '47342204584036', title: '12 Count'},
    '30': {id: '47342204616804', title: '30 Count'}
  };

  function variantFor(data, size) {
    const spec = VARIANTS[size];
    if (!spec) return null;
    return data.variants.find(item => String(item.id) === spec.id && item.title === spec.title) || null;
  }

  function resolve30(data, choice) {
    if (!['once', 'single', 'bundle'].includes(choice)) return {error: 'Choose a purchase option.'};
    if (String(data.productId) !== PRODUCT_ID) return {error: 'This product is unavailable.'};
    const v = variantFor(data, '30');
    if (!v?.available || !Number.isInteger(v.price) || v.price <= 0) return {error: 'The 30-count jar is currently unavailable.'};
    if (choice === 'once') return v.requiresSellingPlan ? {error: 'One-time purchase is unavailable.'} : {item: {id: v.id, quantity: 1}, price: v.price, compare: v.price, variant: v};
    const quantity = choice === 'bundle' ? 3 : 1;
    const days = choice === 'bundle' ? 90 : 30;
    const binding = data.binding?.['30']?.[choice] || data.binding?.[choice];
    const allocation = binding && v.allocations.find(a => String(a.id) === String(binding.planId) && String(a.groupId) === String(binding.groupId) && a.recurring === true);
    if (!allocation || binding.billingDays !== days || binding.deliveryDays !== days || !Number.isInteger(allocation.price) || allocation.price <= 0) return {error: 'This subscription is currently unavailable. You can choose one-time purchase.'};
    if (data.currency !== 'USD') return {error: 'This subscription offer is currently unavailable in your market.'};
    const expected = choice === 'bundle' ? v.price * 2 : Math.round(v.price * 0.9);
    if (allocation.price * quantity !== expected) return {error: 'This subscription offer is currently unavailable. Please choose one-time purchase.'};
    if (!data.shippingApproved) return {error: 'This subscription is currently unavailable. Please choose one-time purchase.', price: allocation.price * quantity, compare: v.price * quantity};
    return {item: {id: v.id, quantity, selling_plan: allocation.id}, price: allocation.price * quantity, compare: v.price * quantity, days, variant: v};
  }

  function resolve12(data, mode, weeks) {
    if (!['once', 'subscription'].includes(mode)) return {error: 'Choose a purchase option.'};
    if (String(data.productId) !== PRODUCT_ID) return {error: 'This product is unavailable.'};
    const v = variantFor(data, '12');
    if (!v?.available || !Number.isInteger(v.price) || v.price <= 0) return {error: 'The 12-count jar is currently unavailable.'};
    if (mode === 'once') return v.requiresSellingPlan ? {error: 'One-time purchase is unavailable.'} : {item: {id: v.id, quantity: 1}, price: v.price, compare: v.price, variant: v};
    const binding = data.binding?.['12'];
    const planId = binding?.plans?.[weeks];
    const groupId = binding?.groups?.[weeks];
    const allocation = planId && groupId && v.allocations.find(a => String(a.id) === String(planId) && String(a.groupId) === String(groupId) && a.recurring === true);
    if (!allocation || !Number.isInteger(allocation.price) || allocation.price <= 0) return {error: 'This subscription is currently unavailable. You can choose one-time purchase.'};
    if (data.currency !== 'USD') return {error: 'This subscription offer is currently unavailable in your market.'};
    if (allocation.price !== Math.round(v.price * 0.9)) return {error: 'This subscription offer is currently unavailable. Please choose one-time purchase.'};
    if (!data.shippingApproved) return {error: 'This subscription is currently unavailable. Please choose one-time purchase.', price: allocation.price, compare: v.price, plan: allocation};
    return {item: {id: v.id, quantity: 1, selling_plan: allocation.id}, price: allocation.price, compare: allocation.compareAtPrice || v.price, days: Number(weeks) * 7, variant: v, plan: allocation};
  }

  function normalize(opts) {
    if (typeof opts === 'string') return {size: '30', choice: opts};
    return opts || {};
  }

  function resolve(data, opts) {
    const request = normalize(opts);
    const size = String(request.size || '30');
    if (size === '12') return resolve12(data, request.mode || 'subscription', String(request.weeks || '4'));
    return resolve30(data, request.choice || 'bundle');
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {resolve};
  else window.PassionCommerce = {resolve};
})();
